/** Shared booking CTA detection + markdown cleanup for future chat. */

export const BOOKING_CARD_MARKER = '<!-- booking-card -->'

const CAL_URL_REGEX = /https?:\/\/[^\s)<>"']*(?:cal\.com|calendly\.com)[^\s)<>"']*/gi
const CAL_MARKDOWN_LINK_REGEX =
  /\[([^\]]*)\]\(\s*https?:\/\/[^\s)]*(?:cal\.com|calendly\.com)[^\s)]*\s*\)/gi

const BOOKING_MENTION_REGEX =
  /\b(?:booking\s*link|bestillingslenke|schedule\s*(?:a\s+)?(?:call|meeting|time)|book\s+(?:a\s+)?(?:call|meeting|time|slot)|here(?:'s| is)\s+(?:the|your|a)\s+link|book\s+(?:directly|a call)|using this link|book a call right here|gratis\s+samtale|neste\s+steg|første\s+steg|forste\s+steg|åpne\s+kalender|apne\s+kalender|planlegg\s+et\s+møte|planlegg\s+et\s+mote)\b/i

/** Model often writes `[Booking Link]` instead of the Cal URL. Widget is the CTA. */
const BOOKING_PLACEHOLDER_PATTERN =
  /\[[^\]]*(?:booking\s*link|bestillingslenke|book(?:ing)?(?:\s+link)?)[^\]]*\](?:\([^)]*\))?/i

export function messageHasBookingWidget(text: string): boolean {
  if (!text?.trim()) return false
  if (text.includes(BOOKING_CARD_MARKER)) return true
  if (/https?:\/\/[^\s)<>"']*(?:cal\.com|calendly\.com)/i.test(text)) return true
  if (BOOKING_PLACEHOLDER_PATTERN.test(text)) return true
  if (BOOKING_MENTION_REGEX.test(text)) return true
  return false
}

/** Remove `[Booking Link]`-style placeholders the model dumps next to the widget. */
export function stripBookingPlaceholders(text: string): string {
  if (!text) return text
  return text
    .replace(new RegExp(BOOKING_PLACEHOLDER_PATTERN.source, 'gi'), '')
    .replace(/[ \t]*:\s*$/gm, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

/** Remove raw Cal links and markers so FutureCalendarWidget is the single CTA. */
export function stripBookingFromMarkdown(text: string): string {
  if (!text) return text

  let out = stripBookingPlaceholders(text)
  out = out.replace(BOOKING_CARD_MARKER, '')
  out = out.replace(CAL_MARKDOWN_LINK_REGEX, '')
  out = out.replace(CAL_URL_REGEX, '')
  out = out.replace(/\bYou can book a call right here:\s*/gi, '')
  out = out.replace(/\bBook a time with Farzad\b/gi, '')
  out = out.replace(/\bWhat time frame were you thinking about\??\s*/gi, '')
  out = out.replace(/[ \t]+\n/g, '\n')
  out = out.replace(/\n{3,}/g, '\n\n')
  return out.trim()
}
